import Vue from "vue"
import Vuex from "vuex"
import Auth from "./modules/auth"
import User from "./modules/user"
import Global from "./modules/global"
import Sync from "./modules/sync"
import Forms from "./modules/forms"
Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Auth,
    User,
    Global,
    Forms,
    Sync,
  },
})
